import React from "react";
import BaseRenderer from "./BaseRenderer";
import Text from "@amzn/meridian/text";
import NumberWidget from "../../components/NumberWidget";
import ChartWidget from "../../components/ChartWidget";

/**
 * Default MyScc Renderer. Based on the passed in widget config renderer chooses the correct component to load.
 */
export default class DefaultRenderer extends BaseRenderer {
  render(widgetSpec, ctx) {
    const widgetType = widgetSpec.widgetDefinition.type;

    switch (widgetType) {
      case "number":
        return (
          <NumberWidget metricData={ctx.metricData} widgetSpec={widgetSpec} />
        );

      case "lineGraph":
        return (
          <ChartWidget metricData={ctx.metricData} widgetSpec={widgetSpec} />
        );

      case "text":
        return (
          <Text style={{ whiteSpace: "pre-wrap" }}>
            {widgetSpec.widgetDefinition.markdown || "No content available"}
          </Text>
        );

      default:
        return <Text>Unknown widget type: {widgetType}</Text>;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mySCC/common/renderers/DefaultRenderer.js